module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_victoria_contra_celulitis_mobile.05136a90.jpg";